import React, { useState } from "react";
import Outgoingdata from "./Table/Outgoingdata";
import { makeStyles } from "@material-ui/core";
import { Stepper } from "@material-ui/core";
import { Step } from "@material-ui/core";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import DeliveryDetails from "./Forms/DeliveryDetails";
import GeneralDetails from "./Forms/GeneralDetails";
import ReviewDetails from "./Forms/ReviewDetails";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ["General Details", "Delivery Location", "Review your Location"];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <GeneralDetails />;
    case 1:
      return <DeliveryDetails />;
    case 2:
      return <ReviewDetails />;
    default:
      return "Unknown stepIndex";
  }
}
export default function Outgoing() {
  const [showModal, setShowModal] = useState(false);

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };


  
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addGoodsinout = Permissions.find((o) => o.codename === "add_goodsinout");

  return (
    <div>
      <h2 class="mt-2 mb-1">
        <div
          class=" w-fit
relative
flex
items-center
py-4
px-5
font-semibold
font-Montserrat
text-base text-blue-200 text-left
bg-transparent
border-0
rounded-none
transition
focus:outline-none
"
        >
          <svg
            className="mr-2 hover:rotate-180"
            width="15"
            height="10"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
              stroke="#1F78B4"
              stroke-width="2"
            />
          </svg>{" "}
          All Outgoing Deliveries
        </div>
      </h2>
      <div class="flex flex-wrap  ">
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto -mt-12 ">
          <div
            className=" overflow-auto float-right"
            // "w-[calc(100vw_-_12rem)]"
          >
          {!addGoodsinout ===undefined ||  addGoodsinout?.codename ===
            "add_goodsinout" ? (
            <button
              type="button"
              class="text-blue-900 font-Montserrat bg-white hover:bg-blue-50 border-1 border-blue-200  focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <svg
                className="pr-2"
                width="21"
                height="17"
                viewBox="0 0 21 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 8.5H21M10.5 0.5V16.5"
                  stroke="#1F78B4"
                  stroke-width="2"
                />
              </svg>
              Add Delivery
            </button> 
            ):null}
            {showModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                    {/*content*/}
                    <div
                      className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                      style={{ width: "40vw" }}
                    >
                      {/*header*/}

                      <div className=" ml-3 flex items-start justify-between mt-4 w-fit rounded-t">
                        <h2 className="font-Montserrat text-xl font-bold text-gray-100">
                          Make a Delivery
                        </h2>
                        <button
                          className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                          onClick={() => setShowModal(false)}
                        >
                          <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                            ×
                          </span>
                        </button>
                      </div>
                      <h3 className="text-sm text-gray-50 pl-3 flex font-Montserrat font-semibold">
                        <p className="text-blue-200 flex">
                          Outgoing
                          {" > "}
                        </p>
                        Make Delivery{" "}
                      </h3>
                      {/*body*/}
                      <div className={classes.root}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                          {steps.map((label) => (
                            <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </div>
                      {/*footer*/}
                      <div className="inline-block px-6 pb-6 rounded-b">
                        <div>
                          {activeStep === steps.length ? (
                            <div>
                              <Typography className="font-Montserrat text-center">
                                All Details completed
                              </Typography>
                              <Button
                                onClick={handleReset}
                                style={{ color: "red" }}
                              >
                                Reset
                              </Button>
                            </div>
                          ) : (
                            <div>
                              <Typography className={classes.instructions}>
                                {getStepContent(activeStep)}
                              </Typography>
                              <div>
                                {activeStep === 0 ? (
                                  <button
                                    className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                  >
                                    Cancel
                                  </button>
                                ) : (
                                  <Button
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    className={classes.backButton}
                                    style={{ color: "rgba(78, 153, 43, 1)" }}
                                  >
                                    Back
                                  </Button>
                                )}
                                <Button
                                  className="float-right bg-green-100"
                                  variant="contained"
                                  style={{
                                    color: "white",
                                    background: "rgba(93, 173, 56, 1)",
                                  }}
                                  onClick={handleNext}
                                >
                                  {activeStep === steps.length - 1
                                    ? "Finish"
                                    : "Next Step"}
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          <Outgoingdata />
        </div>
      </div>
    </div>
  );
}
